module.exports = __webpack_public_path__ + "static/img/new-11.ec96da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-11.png
// module id = I1uy
// module chunks = 0